import React, { useEffect } from "react";

import { useTranslation } from "react-i18next";
import { Mail, Phone, MessageSquare, Instagram, PhoneIcon } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";
import logowhite from "../../assets/TWH1-white.png";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import { indexStore } from "../../store/indexStore";
import i18n from "../../i18n";
function FooterPages() {
  const { t } = useTranslation();
  const { lang, changeLang } = indexStore();

  const handelSelectChange = (e: any) => {
    changeLang(e);
  };
  useEffect(() => {
    const handleLanguageChange = () => {
      i18n.changeLanguage(lang);
      document.documentElement.dir = i18n.dir();
    };

    if (lang) {
      handleLanguageChange();
    } else {
      changeLang(localStorage.getItem("Lang") || "en");
    }
  }, [lang]);
  return (
    <footer className="bg-MainBlue text-white px-6 md:px-16 py-10">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">
        {/* About Section */}
        <div>
          <div className="flex items-center gap-2 mb-4">
            <img src={logowhite} alt="Logo" width={70} height={30} />
          </div>
          <p className="text-sm leading-relaxed">{t("footer.footerDesc")}</p>
          <p className="text-xs mt-6">
            {t("footer.allRightsReserved")} &copy; {new Date().getFullYear()}
          </p>{" "}
        </div>

        {/* Contact Section */}
        <div>
          <h3 className="text-lg font-semibold mb-4">
            {t("footer.contactUs")}
          </h3>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-2 cursor-pointer">
              <Phone size={18} />
              <a href="tel:+971528401112" dir="ltr">
                {" "}
                +971 52 840 1112{" "}
              </a>
            </li>
            <li className="flex items-center gap-2">
              <MessageSquare size={18} />
              <a href="tel:+971528401112" dir="ltr">
                {" "}
                +971 52 840 1112{" "}
              </a>
            </li>
            <li className="flex items-center gap-2">
              <Mail size={18} />{" "}
              <a href="mailto:info@twhmenu.com" dir="ltr">
                info@twhmenu.com
              </a>
            </li>
          </ul>
        </div>

        {/* Quick Links Section */}
        <div>
          <h3 className="text-lg font-semibold mb-4">
            {t("footer.qickLinks")}
          </h3>
          <ul className="space-y-3 text-sm">
            <li>
              <a
                href="/privacy-policy"
                target="_blank"
                rel="noreferrer"
                className="hover:underline"
              >
                {t("pages.privacyPolicy")}
              </a>
            </li>
            <li>
              <a
                href="/terms-of-service"
                target="_blank"
                rel="noreferrer"
                className="hover:underline"
              >
                {t("pages.termsOfService")}
              </a>
            </li>
            <li>
              <a href="/services" className="hover:underline">
                {t("pages.services")}
              </a>
            </li>
          </ul>
          <div className="flex justify-between mt-6 items-center">
            <Select
              onValueChange={handelSelectChange}
              value={lang}
              defaultValue={lang}
            >
              <SelectTrigger className="w-[180px]">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="en">English</SelectItem>
                <SelectItem value="ar">العربية</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
      </div>

      {/* Social Icons */}
      <div className="mt-10 flex gap-6 justify-center md:justify-end max-w-7xl mx-auto">
        <a
          href="https://www.instagram.com/twh.tech?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
          className="hover:text-gray-200"
        >
          <Instagram size={20} />
        </a>
        <a
          href="tel:+971 52 840 1112"
          dir="ltr"
          target="_blank"
          rel="noreferrer"
          className="hover:text-gray-200"
        >
          <PhoneIcon size={20} />
        </a>
        <a
          dir="ltr"
          target="_blank"
          rel="noreferrer"
          href="https://wa.me///+971528401112?text=Hello%21+I+found+TWHMENU.com+and+I+want+to+create+digital+menu"
          className="hover:text-gray-200"
        >
          <FaWhatsapp size={20} />
        </a>
        <a
          href="mailto:info@twhmenu.com"
          dir="ltr"
          target="_blank"
          rel="noreferrer"
          className="hover:text-gray-200"
        >
          <Mail size={20} />
        </a>
      </div>
    </footer>
  );
}

export default FooterPages;

//     {/* <iframe
//       src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3603.0849627424122!2d55.5302562248526!3d25.435422877558317!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ef5f7d5452e90a5%3A0x9897aa61b743bff2!2sTWH%20Interiors!5e0!3m2!1sar!2sae!4v1721483754105!5m2!1sar!2sae"
//       className="w-full rounded-lg h-64 md:h-96 "
//       style={{ border: 0 }}
//       title="map"
//       allowfullscreen=""
//       loading="lazy"
//       referrerpolicy="no-referrer-when-downgrade"
//     ></iframe> */}
//     <div>
//       <div className="flex justify-center items-center gap-3">

// <a
//   className="text-lg  hover:underline"
//   href="/privacy-policy"
//   target="_blank"
//   rel="noreferrer"
// >
//   {t("pages.privacyPolicy")}
//         </a>
//       </div>
//     </div>
//     <div className="text-center text-lg">
//       All rights reserved &copy; {new Date().getFullYear()}
//     </div>
//     {/* <FooterCopy /> */}
//   </div>
// );
